/**
 * Apollo App Interface 관련 함수
 */
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import utils from '@/common/util/utils'

const CHANNEL = 'WAVVE'
/**
 * Apollo 여부 체크
 * @returns {boolean}
 */
export const isApollo = () => {
  let deviceType = utils.cookies.getDevice()

  if (deviceType === DEVICE_TYPE_ANDROID) {
    if (window.ApolloWebCommonHandler) {
      return true
    }
  }
  if (deviceType === DEVICE_TYPE_IOS) {
    if (window.webkit && window.webkit.messageHandlers) {
      return true
    }
  }
  return false
}

/**
 * 아폴로 상,하단 바 고정/고정해제 처리
 * @param fixed
 * @returns {boolean}
 */
export const fixedToolBar = (fixed = true) => {
  if (!isApollo()) {
    return false
  }
  let deviceType = utils.cookies.getDevice()
  let parameter = {
    fixed: fixed
  }
  if (deviceType === DEVICE_TYPE_ANDROID) {
    window.ApolloWebCommonHandler.fixedToolBar(JSON.stringify(parameter))
  } else if (deviceType === DEVICE_TYPE_IOS) {
    window.webkit.messageHandlers.fixedToolBar.postMessage(parameter)
  }
  return true
}

/**
 * 아폴로 웹뷰 닫기
 * @returns {boolean}
 */
export const closeWindow = () => {
  if (!isApollo()) {
    return false
  }
  let deviceType = utils.cookies.getDevice()
  let parameter = {
    result: ''
  }

  if (deviceType === DEVICE_TYPE_ANDROID) {
    window.ApolloWebCommonHandler.closeWindow(JSON.stringify(parameter))
  } else if (deviceType === DEVICE_TYPE_IOS) {
    window.webkit.messageHandlers.closeWindow.postMessage(parameter)
  }
  return true
}

/**
 * 아폴로 native로 cpToken(credential) 재발급 요청
 * @param channel
 * @returns {boolean}
 */
export const requestCPToken = () => {
  if (!isApollo()) {
    return false
  }
  let deviceType = utils.cookies.getDevice()
  let parameter = {
    channel: CHANNEL
  }
  if (deviceType === DEVICE_TYPE_ANDROID) {
    window.ApolloWebCommonHandler.requestCPToken(JSON.stringify(parameter));
  } else if (deviceType === DEVICE_TYPE_IOS) {
    window.webkit.messageHandlers.requestCPToken.postMessage(parameter);
  }
  return true
}

//아폴로 native -> webview interface

/**
 * cpToken 재발급 요청 requestCPToken 응답 함수
 * callback Function 호출(credential 저장 및 플레이어 재 load)
 */
export const setCPTokenResult = (cbFn) => {
  window.setCPTokenResult = function (accessToken) {
    console.log('SHCHO: setCPTokenResult ', accessToken)
    cbFn(accessToken)
  }
}


